var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 10 7"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.411 6.057A.833.833 0 1 0 9.65 4.943L5.73.563a.833.833 0 0 0-1.24 0L.63 4.943a.833.833 0 0 0 1.24 1.114l3.24-3.691z",
    clipRule: "evenodd"
  })));
};
export default SvgArrowUp;